<template>
	<div class="useradmin">
        <el-card>
            <el-button type="success" @click="add()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">添加管理员</el-button>

            <el-input style="margin-left:20px;width:200px" v-model="admin_name" placeholder="请输入管理员" clearable ></el-input>
            <el-button style="margin-left:20px" type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>

            <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="400px">
                <el-row>
                    <el-col :span="6"><span>用户名</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="name" placeholder="用户名"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>手机</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="tell" placeholder="登录账号"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>密码</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="password" placeholder="密码"></el-input>
                    </el-col>
                </el-row>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                    <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
                </span>
            </el-dialog>

            <el-table
                size="mini"
                :data="tableData"
                stripe
                border>
                <el-table-column
                    prop="create_time"
                    label="创建时间">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="用户">
                </el-table-column>

                <el-table-column
                    prop="tell"
                    label="电话">
                </el-table-column>

                <el-table-column
                    prop="password"
                    label="密码">
                </el-table-column>
                
                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>

                <el-table-column label="操作" width="200">
                    <template slot-scope="scope" >
                        <el-button type="primary" size="mini" @click="edit(scope.row)" icon="el-icon-edit">修改</el-button>
                        <el-button type="danger" size="mini" @click="del(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>
    import { adminList,adminAdd,adminEdit,adminDel} from '../router/api';

	export default{
		data(){
			return{
                name:'',
                tell:'',
                password:'',
                user_id:'',
                title:'',
                dialogVisible:false,
                tableData:[],
                admin_name:'',
            }
        },
      
        async mounted() {
            await this.getList()
        },
		methods: {
            async getList() {
                adminList({
                    id:'',
                    name:this.admin_name
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            submit() {
                if(this.name==''||this.tell==''||this.password==''){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.user_id) {
                    adminEdit({
                        name: this.name,
                        tell: this.tell ,
                        password: this.password,
                        user_id: this.user_id,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                } else {
                    adminAdd({
                        name: this.name,
                        tell: this.tell ,
                        password: this.password,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            edit(row) {
                this.dialogVisible = true
                this.name = row.name
                this.tell = row.tell,
                this.password = row.password,
                this.user_id = row.id,
                this.title = '修改管理员'
            },

            add() {
                this.dialogVisible = true
                this.name = ''
                this.tell = '',
                this.password = '',
                this.user_id = '',
                this.title = '添加管理员'
            },
            
            del(row) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    adminDel({
                        id:row.id,
                    }).then(res=> {
                        this.$message.success(res.msg);
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message.error('取消操作');
                });
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .useradmin  {
        .el-row {
            box-sizing: border-box;
            height: 28px;
            line-height: 28px;
            margin-bottom:10px;
        }
        /deep/ .el-dialog__body {
            padding: 10px 20px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
    }
</style>


